// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BestFitPharmacyResultSearchResponse } from './bestFitPharmacyResultSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': BestFitPharmacyResultSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "BestFitPharmacyResultSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse.attributeTypeMap;
    }
}
